import { OrganizationDetailFragment, formatCentsAsDollars } from '@alice-financial/alice-sdk'
import { Box, Grid, SectionHeading, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { useCurrentOrgRootPath } from '../organization/useOrg'
import { ConnectedPaymentMethods } from './ConnectedPaymentMethods'
import { ConnectPaymentMethodStep } from './ConnectPaymentMethodStep'
import { isOrgFundingConnected } from './funding/fundingUtils'
import { FundingAccountBalance } from './FundingAccountComponents'

// Styling is done to match Stripe's own ConnectFinancialAccount widget as much as possible.
const ReserveAccountBalance = ({ org }: { org: OrganizationDetailFragment }) => {
  return (
    <div>
      <Typography variant="caption">Reserve Amount</Typography>
      <Typography variant="h3" style={{ margin: '2px 0 16px', fontSize: '24px' }}>
        {formatCentsAsDollars(org.aliceCardProgram.reserveAmount, false)}{' '}
        <span style={{ fontWeight: 'normal' }}>USD</span>
      </Typography>
      <Typography variant="caption">
        {org.aliceCardProgram.employeeFundingCount} employees @{' '}
        {formatCentsAsDollars(org.aliceCardProgram.perEmployeeFundingAmount, false)} USD each
      </Typography>
    </div>
  )
}

export const AliceCardConnectionInfo = ({ org }: { org: OrganizationDetailFragment }) => {
  const currentOrgRootPath = useCurrentOrgRootPath()
  const isFundingConnected = isOrgFundingConnected(org)
  return (
    <>
      {isFundingConnected && (
        <Box mt={3} mb={4}>
          <SectionHeading
            to={`${currentOrgRootPath}/alice-card-program/account`}
            toLabel="See account activity"
          >
            Contributions Account
          </SectionHeading>
          <Grid container sx={{ marginTop: 2 }}>
            <Grid size={{ xs: 12 }}>
              <Typography variant="body2" gutterBottom>
                Employee spend on Alice Card is automatically transferred regularly from your payroll bank
                account to your contributions account. Transfers made to the contributions account{' '}
                <em>are not Alice&apos;s fees</em>, and the funds do not belong to Alice &ndash; they belong
                to your company&apos;s commuter benefit plan.
              </Typography>
            </Grid>
            <Grid size={{ xs: 6 }}>
              <FundingAccountBalance org={org} />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <ReserveAccountBalance org={org} />
            </Grid>
          </Grid>
        </Box>
      )}
      <Box my={3}>
        <ConnectedPaymentMethods org={org} />
      </Box>
      <ConnectPaymentMethodStep org={org} />
    </>
  )
}
